import $ from 'jquery';
import NumberService from '../service/NumberService';

const updateValue = (counter, add = true) => {
    const control = counter.parents('.control');
    const currentCount = NumberService.getValue(control.data('id'));
    const step = +(control.data('step'));

    if (add) {
        if (control.data('max') === undefined || currentCount < +(control.data('max'))) {
            NumberService.setValue(control.data('id'), currentCount + step);
        }
    } else {
        if (control.data('min') === undefined || currentCount > +(control.data('min'))) {
            NumberService.setValue(control.data('id'), currentCount - step);
        }
    }
};

$('body').on('click', '.control-number__counter--minus', function (e) {
    e.preventDefault();
    updateValue($(this), false);
});

$('body').on('click', '.control-number__counter--plus', function (e) {
    e.preventDefault();
    updateValue($(this), true);
});
